<template>
  <button v-if="!props.isFullscreen" class="close-button" @click="handleClose">
    <i class="uil uil-times close-button__icon" />
  </button>
  <div
    class="paywall-content"
    :class="props.isFullscreen ? 'paywall-content-fullscreen' : ''"
  >
    <div class="paywall__tag">
      Seja PRO <img class="paywall__img" src="/images/diamond.svg" />
    </div>
    <h2 class="paywall__title">
      Alcance a fluência em<br />
      inglês mais rápido com IA
    </h2>

    <div class="benefits-card">
      <div
        v-for="(benefit, index) in benefits"
        :key="index"
        class="benefits-card__item"
      >
        <img
          class="benefits-card__item-icon"
          src="/images/check-with-background.svg"
        />

        <span class="benefits-card__item-text">
          {{ benefit }}
        </span>
      </div>
    </div>

    <div class="paywall-whatsapp">
      <img class="paywall-whatsapp__icon" src="/images/whatsapp-circle.svg" />
      <b class="paywall-whatsapp__periodicity"
        >Pratique inglês diretamente em seu whatsapp</b
      >
      <span class="paywall-whatsapp__tag">Bônus</span>
    </div>

    <div class="paywall-flex-space"></div>

    <a-button
      :loading="purchaseStore.loadingPaywall"
      type="primary"
      shape="round"
      class="continue-button"
      @click="emit('onBuy')"
    >
      <div
        v-if="!purchaseStore.loadingPaywall"
        class="continue-button__content"
      >
        <div class="continue-button__badge">Desconto de 60%</div>
        <div class="continue-button__text">
          <div class="continue-button__title">
            Quero ser PRO
            <img
              class="continue-button__text-img"
              src="/images/diamond-white.svg"
            />
          </div>
          <div class="continue-button__subtitle">Hoje apenas 12 x R$ 39,00</div>
        </div>
        <i class="uil uil-arrow-right continue-button__icon" />
      </div>
    </a-button>
    <div class="background-image"></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import pressHaptic from '@/helpers/press-haptic';
import { usePurchaseStore } from '@/store/purchase';

type VersionProps = {
  isFullscreen?: boolean;
};

const props = withDefaults(defineProps<VersionProps>(), {
  isFullscreen: false,
});

const purchaseStore = usePurchaseStore();

const benefits = ref([
  'BeConfident PRO 12 meses (R$ 1.200,00)',
  '2 aulas de conversação ao vivo com professores gringos',
  'E-books com mil palavras e mil frases mais usadas no inglês',
  'Comunidade BeConfident',
  'Treinamento BeConfident PRO e Suporte Premium',
]);

const emit = defineEmits(['close', 'onBuy']);

function handleClose() {
  pressHaptic('impactLight');
  emit('close');
}
</script>

<style lang="scss" scoped>
.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 30%;
  z-index: -1;
  overflow: hidden;
  background-image: url('/images/paywall.png');
  background-size: cover;
  background-position: center;
}

.paywall {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;

  :deep(.paywall__container) {
    height: 100vh;
    background-color: var(--color-brand-05);
    bottom: auto;
    max-height: 100vh;
    padding-bottom: 0px !important;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .paywall-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    padding: 16px;
    padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
    padding-top: calc(env(safe-area-inset-top) + 100px);
  }

  .paywall-content-fullscreen {
    padding-top: calc(env(safe-area-inset-top) + 236px);
  }

  &__tag {
    background-color: var(--color-independence-02);
    color: var(--color-independence-05);
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
    margin: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__img {
    padding-left: 5px;
  }

  &__title {
    font-weight: bold;
    margin-top: 20px;
    width: 100%;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: var(--color-contrast-oninteractive);
    font-size: 28px;
    line-height: 120%;
  }

  .benefits-card {
    border-radius: 12px;
    padding: 8px 0px;

    margin: 5px 0;

    &__item {
      display: flex;
      align-items: center;
      text-align: start;
      margin: 10px 0;

      &-icon {
        width: 17px;
        height: 17px;
      }

      &-text {
        margin-left: 14px;
        font-size: 14px;
        font-weight: 500;
        color: var(--color-contrast-oninteractive);
      }
    }
  }

  .paywall-flex-space {
    flex: 1 1 auto;
  }

  .paywall-whatsapp {
    padding: 10px;
    margin: 10px 0px;
    border-radius: 16px;
    font-size: 14px;
    text-align: left;
    display: flex;
    justify-content: space-betweens;
    color: var(--color-contrast-oninteractive);
    border: 1px solid var(--color-brand-02);

    &__periodicity {
      font-weight: 500;
      flex: 1 1 auto;
      margin: 0px 10px;
    }

    &__tag {
      background-color: var(--color-independence-02);
      color: var(--color-independence-05);
      padding: 6px 12px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      margin: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    &__icon {
      width: 32px;
      height: 32px;
      margin: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .continue-button {
    width: 100%;
    margin-top: 30px;
    display: flex;
    align-items: center;
    position: relative;

    &__badge {
      position: absolute;
      top: -25px;
      right: 16px;
      background-color: var(--color-opportunity-03);
      color: var(--color-opportunity-05);
      padding: 4px 8px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 8px;
      z-index: 2;
      white-space: nowrap;
    }

    &__content {
      position: relative;
      padding: 0 16px;
      color: var(--color-contrast-oninteractive);
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      line-height: 20px;
      margin-left: 15px;
    }

    &__text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &-img {
        width: 16px;
        height: 16px;
      }
    }

    &__title {
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 16px;
      font-weight: 700;
    }

    &__subtitle {
      font-size: 14px;
      font-weight: 500;
    }

    &__icon {
      font-size: 24px;
      color: var(--color-contrast-oninteractive);
    }
  }
}

.close-button {
  position: absolute;
  top: calc(env(safe-area-inset-top) + 8px);
  right: 20px;
  background-color: var(--color-contrast-oninteractive);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  padding: 1px;

  &__icon {
    color: var(--color-brand-04);
    font-size: 20px;
  }
}
</style>
